import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// common
import { updateReportFromReportListSuccess } from '../../common/actions';
// features
import { receivedLogOutSuccess } from '../auth/actions';
// helpers/constants
import * as G from '../../helpers';
// report-common
import { getReportReducers } from '../../report-common';
// feature report-format
import * as A from './actions';
//////////////////////////////////////////////////

const initial = {
  filterProps: [],
  isEditPage: false,
  ignorePrompt: false,
  usedReportStatus: false,
};

const {
  setReports,
  selectItem,
  initialState,
  setUsedReport,
  setListLoading,
  setInitialState,
  setReportPending,
  cleanQuickFilter,
  setTableTitleSort,
  getItemListSuccess,
  setTableTitleFilter,
  setQuickFilterParams,
  resetListAndPagination,
  handleUpdateReportFromReportListSuccess,
} = getReportReducers(initial);

const setEditPage = (state, data) => (
  P.$set('isEditPage', data, state)
);

const receivedUsedReportSuccess = (state, data) => (
  P.$all(
    P.$set('usedReport', data),
    P.$set('reportPending', false),
    state,
  )
);

const receivedDeleteReportSuccess = (state, guid) => (
  P.$all(
    P.$drop(`itemList.${guid}`),
    P.$set('pagination.offset', R.subtract(R.path(['pagination', 'offset'], state), 1)),
    P.$set('totalCount', G.ifElse(R.equals(state.totalCount, 0), 0, R.dec(state.totalCount))),
    state,
  )
);

const setUsedReportStatus = (state, data) => (
  P.$set('usedReportStatus', data, state)
);

const setIgnorePromptStatus = (state, data) => (
  P.$set('ignorePrompt', data, state)
);

const setFilterProps = (state, data) => (
  P.$set('filterProps', data, state)
);

export default createReducer({
  [A.setReports]: setReports,
  [A.selectItem]: selectItem,
  [A.setEditPage]: setEditPage,
  [A.setUsedReport]: setUsedReport,
  [A.setFilterProps]: setFilterProps,
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setReportPending]: setReportPending,
  [A.cleanQuickFilter]: cleanQuickFilter,
  [A.setTableTitleSort]: setTableTitleSort,
  [receivedLogOutSuccess]: setInitialState,
  [A.getItemListSuccess]: getItemListSuccess,
  [A.cleanReportStateAction]: setInitialState,
  [A.setTableTitleFilter]: setTableTitleFilter,
  [A.setUsedReportStatus]: setUsedReportStatus,
  [A.setQuickFilterParams]: setQuickFilterParams,
  [A.setIgnorePromptStatus]: setIgnorePromptStatus,
  [A.resetListAndPagination]: resetListAndPagination,
  [A.receivedUsedReportSuccess]: receivedUsedReportSuccess,
  [A.receivedDeleteReportSuccess]: receivedDeleteReportSuccess,
  [updateReportFromReportListSuccess]: handleUpdateReportFromReportListSuccess,
}, initialState);
